import {z} from '@hono/zod-openapi';

export const priceReportApiKeyHeaderSchema = z.object({
  // Declared optional so zod cannot answer its own 400 for an absent header and preempt the
  // middleware, which owns this: no credential is a 401, not a malformed request.
  'x-api-key': z.string().optional(),
});
